import { getUploadUrl } from '@/lib/api';

/**
 * Extrae la URL bruta de una foto que puede ser string o {src|url|path|href}.
 */
function extractRaw(f) {
  if (!f) return '';
  if (typeof f === 'string') return f;
  if (typeof f === 'object') return f.src || f.url || f.path || f.href || '';
  return '';
}

/**
 * Decide si un raw es una referencia válida (no solo slashes / null / espacios).
 */
function isValidRaw(raw) {
  if (typeof raw !== 'string') return false;
  const clean = raw.trim().replace(/\/+$/, '').replace(/^\/+/, '');
  if (!clean) return false;
  if (clean === 'null' || clean === 'undefined') return false;
  // Necesita al menos un punto (extension) o un segmento real
  return clean.length >= 3;
}

function mapFotos(arr, tipo) {
  return (arr || [])
    .map((f) => {
      const raw = extractRaw(f);
      if (!isValidRaw(raw)) return null;
      return { url: getUploadUrl(raw), tipo };
    })
    .filter((f) => f && f.url && !f.url.startsWith('blob:') && !f.url.startsWith('data:'));
}

function dedup(arr, ya) {
  return arr
    .filter((f) => f.url)
    .filter((f) => !ya.has(f.url))
    .map((f) => {
      ya.add(f.url);
      return f;
    });
}

/**
 * Agrupa las fotos de la OT por fase (Recepción → Antes → Después → Otras)
 * y construye las páginas del anexo (8 fotos por página A4).
 *
 * @param {object} orden - documento de la OT
 * @param {boolean} includeFotos - si false devuelve estructuras vacías
 * @param {boolean} isBlank - si true (modo "blanco") no incluye fotos
 */
export function buildPhotoPages(orden, { includeFotos, isBlank }) {
  const vistas = new Set();
  const fotosPorFase = [
    {
      fase: 'Recepción',
      fotos: dedup(
        [
          ...mapFotos(orden?.fotos_recepcion, 'Recepción'),
          ...mapFotos(orden?.ri_fotos_recepcion, 'Recepción'),
        ],
        vistas,
      ),
    },
    {
      fase: 'Antes de la reparación',
      fotos: dedup(mapFotos(orden?.fotos_antes, 'Antes'), vistas),
    },
    {
      fase: 'Después de la reparación',
      fotos: dedup(mapFotos(orden?.fotos_despues, 'Después'), vistas),
    },
    {
      fase: 'Otras evidencias',
      fotos: dedup(
        [
          ...mapFotos(orden?.evidencias, 'Admin'),
          ...mapFotos(orden?.evidencias_tecnico, 'Técnico'),
        ],
        vistas,
      ),
    },
  ].filter((g) => g.fotos.length > 0);

  const allFotos = fotosPorFase.flatMap((g) => g.fotos).slice(0, 32);

  const photoPages = [];
  if (includeFotos && !isBlank && fotosPorFase.length > 0) {
    fotosPorFase.forEach((grupo) => {
      const total = Math.ceil(grupo.fotos.length / 6);
      for (let i = 0; i < grupo.fotos.length; i += 6) {
        photoPages.push({
          fase: grupo.fase,
          fotos: grupo.fotos.slice(i, i + 6),
          paginaFase: Math.floor(i / 6) + 1,
          totalFase: total,
        });
      }
    });
  }

  return { fotosPorFase, allFotos, photoPages };
}
